import offerRoutes from './offers/offers-routes'
import layoutRoutes from './layout/layout-routes'
import requirementsRoutes from './requirements/requirements-routes'
import modifiersRoutes from './modifiers/modifiers-routes'
import menuItemsRoutes from './menu-items/menu-items-routes'

export default [
  {
    path: '/menu',
    component: () => import('./Menu.vue'),
    children: [
      {
        path: 'admin',
        component: () => import('./menus-admin/MenusAdmin.vue'),
        name: 'menusAdmin'
      },
      {
        path: 'import',
        component: () => import('./menus-admin/menus-import/MenusImport.vue'),
        name: 'menusImport'
      },
      {
        path: 'publish',
        component: () => import('./menus-admin/menus-publish/MenusPublish.vue'),
        name: 'menusPublish'
      },
      {
        path: 'taxStructures',
        component: () => import('./tax-structures/TaxStructures.vue'),
        name: 'taxStructures'
      },
      menuItemsRoutes,
      {
        path: 'printers',
        component: () => import('./printers/MenuPrinters'),
        name: 'menuPrinters'
      },
      {
        path: 'kps',
        component: () => import('./kps/Kps'),
        name: 'kps'
      },
      {
        path: 'pricingSchemes',
        component: () => import('./pricing-schemes/PricingSchemes.vue'),
        name: 'pricingSchemes'
      },
      ...modifiersRoutes,
      {
        path: 'messages',
        component: () => import('./messages/Messages'),
        name: 'menuMessages'
      },
      ...requirementsRoutes,
      {
        path: 'onlineCategories',
        component: () => import('./online-categories/OnlineMenuCategories'),
        name: 'onlineCategories'
      },
      ...offerRoutes,
      ...layoutRoutes,
      {
        path: 'imageManager',
        component: () => import('./image-manager/ImageManager'),
        name: 'imageManager'
      }
    ]
  },
  {
    path: '/changeMenu',
    component: () => import('./ChangeMenu.vue'),
    name: 'changeMenu'
  }
]
